// HR-only routes
import type { RouteRecordRaw } from 'vue-router';

import LoginDashboard from '../views/dashboard/DashboardIndex.vue';
import NewsEventsPage from '../views/dashboard/NewsEventsPage.vue';
import CircularsPage from '../views/dashboard/CircularsPage.vue';
import SOPDocumentsPage from '../views/dashboard/SOPDocumentsPage.vue';
import NewsEventDetailPage from '../views/dashboard/NewsEventDetailPage.vue';
import NewsEventFormPage from '../views/dashboard/NewsEventFormPage.vue';
import CircularDetailPage from '../views/dashboard/CircularDetailPage.vue';
import CircularFormPage from '../views/dashboard/CircularFormPage.vue';
import SOPDocumentDetailPage from '../views/dashboard/SOPDocumentDetailPage.vue';
import SOPDocumentFormPage from '../views/dashboard/SOPDocumentFormPage.vue';
import AuthLogin from '../views/auth/LoginView.vue';
import AuthForgotPassword from '../views/auth/ForgotPasswordView.vue';

import { hrRoutes } from '../modules/hr/router/index';

export const unifiedRoutes: RouteRecordRaw[] = [
    {
        path: '/',
        redirect: '/auth/login'
    },
    {
        path: '/auth',
        children: [
            {
                path: 'login',
                name: 'Login',
                component: AuthLogin
            },
            {
                path: 'forgot-password',
                name: 'ForgotPassword',
                component: AuthForgotPassword
            },
            {
                // Public self-service signup. Anonymous by design: nobody has an
                // account yet, so this must sit outside requiresAuth.
                path: 'signup',
                name: 'Signup',
                component: () => import('../views/auth/SignupView.vue')
            },
            {
                // Lands the emailed verification link and provisions the tenant.
                path: 'verify',
                name: 'VerifySignup',
                component: () => import('../views/auth/VerifySignupView.vue')
            }
        ]
    },
    {
        // The candidate's own document page.
        //
        // Anonymous, outside /auth, and outside the app shell — the person
        // opening it is not a user, has no account, and must not be shown a
        // menu. The token in the path is the whole credential, so it is never
        // put in localStorage and never logged.
        path: '/candidate/:token',
        name: 'CandidatePortal',
        component: () => import('../views/candidate/CandidatePortalView.vue')
    },
    {
        path: '/dashboard',
        name: 'Dashboard',
        component: LoginDashboard,
        meta: { requiresAuth: true }
    },
    {
        path: '/news-events',
        name: 'NewsEvents',
        component: NewsEventsPage,
        meta: { requiresAuth: true }
    },
    {
        path: '/circulars',
        name: 'Circulars',
        component: CircularsPage,
        meta: { requiresAuth: true }
    },
    {
        path: '/sop-documents',
        name: 'SOPDocuments',
        component: SOPDocumentsPage,
        meta: { requiresAuth: true }
    },
    {
        path: '/news-events/create',
        name: 'NewsEventCreate',
        component: NewsEventFormPage,
        meta: { requiresAuth: true }
    },
    {
        path: '/news-events/:id',
        name: 'NewsEventDetail',
        component: NewsEventDetailPage,
        meta: { requiresAuth: true }
    },
    {
        path: '/news-events/:id/edit',
        name: 'NewsEventEdit',
        component: NewsEventFormPage,
        meta: { requiresAuth: true }
    },
    {
        path: '/circulars/create',
        name: 'CircularCreate',
        component: CircularFormPage,
        meta: { requiresAuth: true }
    },
    {
        path: '/circulars/:id',
        name: 'CircularDetail',
        component: CircularDetailPage,
        meta: { requiresAuth: true }
    },
    {
        path: '/circulars/:id/edit',
        name: 'CircularEdit',
        component: CircularFormPage,
        meta: { requiresAuth: true }
    },
    {
        path: '/sop-documents/create',
        name: 'SOPDocumentCreate',
        component: SOPDocumentFormPage,
        meta: { requiresAuth: true }
    },
    {
        path: '/sop-documents/:id',
        name: 'SOPDocumentDetail',
        component: SOPDocumentDetailPage,
        meta: { requiresAuth: true }
    },
    {
        path: '/sop-documents/:id/edit',
        name: 'SOPDocumentEdit',
        component: SOPDocumentFormPage,
        meta: { requiresAuth: true }
    },
    {
        path: '/ONELayout',
        name: 'ONELayout',
        component: () => import('../Layout/ONELayout.vue'),
        meta: { requiresAuth: true, moduleType: 'oneui' },
        children: []
    },
    // HR module is rendered inside its own topbar + mega-menu layout (HrLayout),
    // not the ONELayout sidebar shell.
    ...hrRoutes,
];
